import { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

export default function Image({ ...props }) {
    // const [errored, setErrored] = useState(false);
    //
    // const handleError = (event) => {
    //     if (!errored) {
    //         // console.log('error');
    //         setErrored(true);
    //         event.currentTarget.src="/assets/images/placeholder.jpg";
    //     }
    // }

    return (
        <img loading="lazy" {...props} />
        // <LazyLoadImage effect="blur" loading="lazy" onError={handleError} {...props}/>
    );
}
